import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import   {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { FacturaService } from '../../services/factures-service/factures.service';

import { FListService } from '../services/factures-list.service';

@Component({
  selector: 'mcrit-gestio-factures-filtres',
  templateUrl: 'factures-filtre.component.html',
  styleUrls: ['factures-filtre.component.css'],
  providers: []
})
export class FacturesFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, public languageService: LanguageService, private listService: FListService,private facturaService: FacturaService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters(){
    this.filterModel = {data_cobrament: null, data_cobrament_prevista: null, data_factura: null,
                        data_factura_prevista: null, numero_factura: null, projecte_codi: null, 
                        stateCharged: false, statePending: true, stateWaiting: false};
    //const newFilter = {};
    //for (let key of this.filterModel)newFilter[key] = null;
    //this.listService.valFiltres={};
    //this.filterModel = newFilter;
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    this.filterModel = this.validFilters.reduce((acum, curr) => {
      curr.inputs.forEach(inputGroup => {
        switch (inputGroup.type) {
          case 'select':
            acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
            break;
          default:
            inputGroup.values.forEach(input => {
              if (input.autocomplete)requestedAutocompletes.push(input.autocomplete);
              acum[input.name] = (input.value ? input.value : null);
            });
        }
      });

      return acum;
    }, {});

    this.dataLists = requestedAutocompletes.map(id => {
      return {
        id: id,
        options: this.facturaService.getAutocomplete(id)
      };
    });
    this.sendActiveFilters();
  }
}
